import { useEffect, useRef, useState } from 'react';

// Always shares a link back to our own recall page (not the government
// source link) so shares drive traffic to this site instead of away from it.
//
// The link points at /share/recall/:id rather than straight at the SPA
// page. On the production site that path is a Render rewrite rule (set in
// the static site's dashboard, not in this repo) proxying to the backend's
// /share route, which detects social-preview crawlers (they never run JS)
// and serves them a tiny static page with this specific recall's
// title/image/description as OG tags, so shared links get a real preview
// card instead of the site's generic one. Real visitors hitting the same
// URL are 302-redirected straight to the SPA page.
//
// A fixed site URL is used instead of window.location.origin because inside
// the Capacitor Android app the origin is https://localhost, which would
// produce dead links.
const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://takaisinvedot.fi';

export const useShareRecall = () => {
    const [justCopied, setJustCopied] = useState(false);
    const copiedTimerRef = useRef(null);

    useEffect(() => {
        return () => clearTimeout(copiedTimerRef.current);
    }, []);

    const share = async (item) => {
        const shareUrl = `${SITE_URL}/share/recall/${item._id}`;
        const shareData = { title: item.title, url: shareUrl };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (err) {
                // user cancelled the share sheet, nothing to do
            }
            return;
        }

        try {
            await navigator.clipboard.writeText(shareUrl);
            setJustCopied(true);
            clearTimeout(copiedTimerRef.current);
            copiedTimerRef.current = setTimeout(() => setJustCopied(false), 2000);
        } catch (err) {
            console.error("Failed to copy share link:", err);
        }
    };

    return { share, justCopied };
};
